import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import { BToast } from 'bootstrap-vue'
import Agenda from '@/views/configuracoes/Agenda'
import util from '@/util'
import mensagens from '@/util/mensagens'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'configuracoes',
  components: {
    cabecalho,
    menuLateral,
    Agenda,
    'b-toast': BToast
  },

  computed: {
    ...mapState('configuracoes', ['agenda', 'dadosRetorno', 'flagsDeControle']),
    ...mapGetters('configuracoes', ['sincronizacaoCaldavPermitida', 'sincronizacaoICalPermitida'])
  },

  data: () => {
    return {
      flagAbaAgenda: false
    }
  },

  mounted () {
    this.ActionResetarDadosRetornoCadastro()
    this.ActionResetarDadosFormularioAgenda()
    this.ActionResetarDadosAgenda()
    this.resetarFlagAbasConfiguracoes()
    this.obterConfiguracoes()
  },

  methods: {
    ...mapActions('configuracoes', ['ActionResetarDadosAgenda', 'ActionResetarDadosFormularioAgenda', 'ActionResetarDadosRetornoCadastro', 'ActionDefinirDadosConfiguracoes', 'ActionDefinirDadosRetornoCadastro']),

    async obterConfiguracoes () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

        await this.ActionDefinirDadosConfiguracoes()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, mensagens.carregandoDadosEdicao)
    },

    async salvarConfiguracoes () {
      try {
        this.definirFlagManipulandoDados(true, mensagens.salvandoDadosCadastro)

        const dadosFormularioAgenda = this.obterDadosFormularioAgenda()
        const objetoDeEnvio = { ...dadosFormularioAgenda }

        const resposta = await this.axios.post('configuracoes', objetoDeEnvio)
        this.ActionDefinirDadosRetornoCadastro(resposta.data.retorno)

        this.tratarAposSalvarRegistro()
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorSalvandoDados)
      }
      this.definirFlagManipulandoDados(false, '')
    },

    obterDadosFormularioAgenda () {
      if (this.sincronizacaoCaldavPermitida === false && this.sincronizacaoICalPermitida === false) {
        this.agenda.formulario.enableCaldavSync = false
      }

      if (this.agenda.formulario.enableCaldavSync === false) {
        this.agenda.formulario.f_caldav_password = null
      }
      const dadosFormularioAgenda = util.mapearObjetos(this.agenda.formulario, {})
      const objetoDeEnvio = this.montarObjetoDeEnvio(dadosFormularioAgenda)

      return objetoDeEnvio
    },

    async tratarAposSalvarRegistro () {
      if (this.dadosRetorno.sucesso) {
        util.criarAlertaToastDeSucesso(this, 'Aviso', 'Dados salvos com sucesso.')
        this.ActionResetarDadosRetornoCadastro()
        this.ActionResetarDadosFormularioAgenda()
        this.ActionResetarDadosAgenda()
        this.resetarFlagAbasConfiguracoes()
        await this.obterConfiguracoes()
      } else {
        this.obterAbasComErros()
        util.criarAlertaToastDeErro(this, 'Aviso', this.dadosRetorno.mensagem)
      }
    },

    montarObjetoDeEnvio (dadosFormulario) {
      const campos = Object.entries(dadosFormulario)
        .filter(([chave, valor]) => valor !== null)
        .reduce((acc, [chave, valor]) => ({ ...acc, [chave]: valor }), {})

      return campos
    },

    obterAbasComErros () {
      const erros = Object.values(this.dadosRetorno.listaDeErros)
      const formularioAgenda = Object.values(this.agenda.formulario)

      const abaAgendaPossuiErro = formularioAgenda.some(chave => {
        return erros[chave] !== null
      })
      this.flagAbaAgenda = abaAgendaPossuiErro
    },

    resetarFlagAbasConfiguracoes () {
      this.flagAbaAgenda = false
    },

    definirFlagManipulandoDados (status, mensagem) {
      this.flagsDeControle.manipulandoDados.status = status
      this.flagsDeControle.manipulandoDados.mensagem = mensagem
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    }
  }
}
